import FilesTab from './FilesTab.vue';
export default FilesTab;
